import { Tabs as BootstrapTabs, Tab as BootstrapTab } from 'react-bootstrap';
export var Tabs = BootstrapTabs;
export var Tab = BootstrapTab;